<template>
    <Registration></Registration>
</template>

<script>
    import Registration from "../components/Registration";

    export default {
        name: "registration",
        components: {
            Registration,
        }
    };
</script>